import DefaultProgressDetails from "src/components/feature/ProgressDetails";

const ProgressDetails = () => {
  return <DefaultProgressDetails />;
};

export default ProgressDetails;
